module.exports = __webpack_public_path__ + "assets/img/Airplane.cc7e6ed8.png";